module.exports = __webpack_public_path__ + "fontawesome-webfont.2980083682e94d33a66e.svg";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/fontawesome/fontawesome-webfont.svg?v=4.3.0
// module id = ../../../../../src/assets/css/fonts/fontawesome/fontawesome-webfont.svg?v=4.3.0
// module chunks = 2